import { http } from '@/http'

export default {
  getByEmployee(employeeId) {
    return http.get(`/employees/${employeeId}/dependents`)
  },
  getById(employeeId, dependentId) {
    return http.get(`/employees/${employeeId}/dependents/${dependentId}`)
  },
  create(employeeId, data) {
    return http.post(`/employees/${employeeId}/dependents`, data)
  },
  update(employeeId, dependentId, data) {
    return http.put(`/employees/${employeeId}/dependents/${dependentId}`, data)
  },
  deactivate(employeeId, dependentId) {
    return http.put(`/employees/${employeeId}/dependents/${dependentId}/deactivate`)
  },
  getSummary(employeeId) {
    return http.get(`/employees/${employeeId}/dependents/summary`)
  },
}
